import { useState } from 'react';

import { ErrorModal } from '../../../../modals';
import { Modal, Text, Textarea, Button, Icon } from '@ui-component-library';
import { TailwindWrapper } from '@utils/TailwindWrapper';

import { feedbackSubmission } from '../../../../api/services/dfr';

const ratingOptions = [
    {label: 'Mindre nöjd', value: 'bad', icon: 'SmileySadSimple'},
    {label: 'Helt okej', value: 'neutral', icon: 'SmileyMehSimple'},
    {label: 'Väldigt nöjd', value: 'good', icon: 'SmileySimple'}
]

export default function FeedbackModal({show, setShow}) {
    const [rating, setRating] = useState(null);
    const [tags, setTags] = useState([]);
    const [comment, setComment] = useState('');

    const [error, setError] = useState({});
    const [errorModal, setErrorModal] = useState(false);

    const [success, setSuccess] = useState(false);

    const smileyButton = item => {
        const classes = rating == item.value ? 'bg-charcoal-500 border-charcoal-500 white' : 'charcoal-500 border-pebble-50 bg-white'
        const iconColor = rating == item.value ? 'spring-yellow-500' : 'charcoal-500'
        return <div className='col px-1'>
            <div role='button' className={`text-center border border ${classes}`} style={{borderRadius: '12px', padding: '12px 0'}} onClick={() => setRating(item.value)}>
                <Icon name={item.icon} className={`fill-${iconColor}`} size='xlarge' />
                <Text className='whitespace-nowrap user-select-none' style={{marginTop: '16px'}} variant="text-base/leading-normal/medium">{item.label}</Text>
            </div>
        </div>
    }

    const tagItem = item => {
        const exists = tags.find(tag => tag.value == item.value)
        const classes = exists ? 'bg-charcoal-500 border-charcoal-500 white' : 'charcoal-500 border-pebble-50 bg-white'
        return <div role='button' className={`rounded rounded-2xl border border px-2 py-1 ${classes}`} onClick={() => setTags(exists ? tags.filter(t => t.value != item.value) : [...tags, item])}>
            <Text className='whitespace-nowrap user-select-none' variant="text-sm/leading-normal/medium">{item.label}</Text>
        </div>
    }

    const handleSubmit = async () => {
        if(rating) {
            const data = { rating: rating, tags: tags.map(tag => tag.value).join(';'), comment: comment }

            const resp = await feedbackSubmission(data)
            console.log('resp', resp)
            if(resp.ok) {
                setSuccess(true)
            } else {
                setErrorModal(true)
            }
        } else {
            setError({rating: 'Vänligen välj ett alternativ för att gå vidare.'})
        }
    }

    const closeModal = () => {
        setSuccess(false)
        setShow(false)
        setRating(null)
        setTags([])
        setComment('')
    }

    const formContent = () => {
        return <Modal.Content>
            <div className='flex flex-col justify-around gap-4'>
                <div>
                    <Text style={{marginBottom: '16px'}} variant="text-base/leading-normal/normal">Vad är din upplevelse av tjänsten? *</Text>

                    <div className='flex'>
                        {ratingOptions.map(option => smileyButton(option))}
                    </div>

                    {error.rating && <Text className="text-danger-500" variant="text-xs/leading-normal/normal">{error.rating}</Text>}
                </div>
                
                {Window.react_data.dfr_feedback_tags && <div>
                    <Text style={{marginBottom: '16px'}} variant="text-base/leading-normal/normal">Välj en eller flera som passar in</Text>
                    <div className='flex flex-wrap items-center gap-1'>
                        {Window.react_data.dfr_feedback_tags.map(option => tagItem(option))}
                    </div>
                </div>}
                
                <div>
                    <Text style={{marginBottom: '16px'}} variant="text-base/leading-normal/normal">Vill du lägga till något mer? (frivilligt)</Text>
                    <Textarea value={comment} onChange={(value) => setComment(value)} rows={5} placeholder='Exempelvis: vad som var bra, saknades eller kändes otydligt.' />
                </div>
            </div>
        </Modal.Content>
    }

    const successContent = () => { 
        return <div className='flex flex-col items-center justify-center h-full p-4'>
            <div className='flex items-center justify-center rounded rounded-full bg-stone-100 mb-4' style={{width: '60px', height: '60px'}}>
                <Icon name='CheckSimple' className="fill-charcoal-500" size='xlarge' />
            </div>
            <Text variant="text-lg/leading-normal/medium" lg="text-xl/leading-normal/medium" style={{marginBottom: '12px'}}>Tack för din feedback!</Text>
            <Text variant="text-lg/leading-normal/normal">Det hjälper oss att förbättra tjänsten.</Text>
        </div>
    }

    return <>
        <TailwindWrapper>
            <Modal isOpen={show} borderless>
                <Modal.Header>
                    <Text className='w-full text-center' variant="text-sm/leading-normal/medium">{!success ? 'Hjälp oss att förbättra skogsövervakning' : ''}</Text>

                    <div role='button' onClick={closeModal}>
                        <Icon name='CrossSimple' size='large' />
                    </div>
                </Modal.Header>

                {!success && formContent()}
                {success && successContent()}

                <Modal.Footer>
                    {!success && <Button className='w-full' onClick={handleSubmit}>Skicka feedback</Button>}
                    {success && <Button className='w-full' onClick={closeModal}>Tillbaka till skogsövervakning</Button>}
                </Modal.Footer>
            </Modal>
        </TailwindWrapper>

        <ErrorModal show={errorModal} onToggle={() => setErrorModal(false)} />
    </>
};
